import { FormLabel, type FormLabelProps, Icon, Tooltip } from "@chakra-ui/react";
import { type ReactNode } from "react";
import { FiInfo } from "react-icons/fi";

interface FormLabelWithInfoProps extends FormLabelProps {
  tooltip?: string | null;
  suffix?: ReactNode;
}

export const FormLabelWithInfo = ({ tooltip, suffix, children, ...props }: FormLabelWithInfoProps) => (
  <FormLabel {...props}>
    {children}
    {tooltip && (
      <Tooltip label={tooltip} hasArrow placement="top" rounded="md" fontSize="sm" maxW="300px" px="3" py="2">
        <span>
          <Icon as={FiInfo} color="smMuted" boxSize="4" ml="2" mb="-0.5" cursor="help" />
        </span>
      </Tooltip>
    )}
    {suffix}
  </FormLabel>
);
